// vue-i18n's own options. French is the language every text is written in first (lang/fr.json): a key another
// language does not have yet shows in French rather than as its path, and says so in development only.
export default defineI18nConfig(() => ({
  legacy: false,
  fallbackLocale: "fr",
  missingWarn: process.env.NODE_ENV !== "production",
  fallbackWarn: false
}));
